class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.modal = this.closest('.search-modal');
        this.cachedResults = {};
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
        this.isOpen = false;
        this.searchTerm = '';

        this.setupEventListeners();
    }

    setupEventListeners() {
        this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this));
        this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
        this.querySelector('button[type="reset"]').addEventListener('click', this.clear.bind(this));

        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));

        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));

        this.onClickClose();
    }

    toggleFakeButton() {
        const fakeButtons = document.querySelectorAll('.fake-div-search');
        fakeButtons.forEach(fakeButton => {
            if (this.searchTerm.length) {
                fakeButton.classList.add('hide');
            } else {
                fakeButton.classList.remove('hide');
            }
        });
    }
    clearPredectiveSearchMobile() {
        const predictiveSearchHeader = document.querySelector('.input-search-header-mobile .predictive-search--header');
        if (predictiveSearchHeader && window.innerWidth < 991) {
            predictiveSearchHeader.innerHTML = '';
        }
    }
    onClickClose() {
        const closeButtons = this.querySelectorAll('.close__button');
        const detailsElement = document.querySelector('details.input-search-header-desktop.search-template');
        closeButtons.forEach(closeButton => {
            closeButton.addEventListener('click', (event) => {
                this.clear(event);
                this.clearPredectiveSearchMobile();
                document.querySelectorAll('input[type="search"]').forEach(input => {
                    input.value = '';
                });
                if (detailsElement) {
                    detailsElement.classList.remove('search-template');
                }
                this.onChange();
            });
        });
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        const newSearchTerm = this.getQuery();
        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
            // Remove the results when they are no longer relevant for the new search term
            // so they don't show up when the dropdown opens again
            this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
        }

        // Update the term asap, don't wait for the predictive search query to finish loading
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);
        this.searchTerm = newSearchTerm;
        this.toggleFakeButton();
        if (!this.searchTerm.length) {
            this.clear();
            this.close(true);

            return;
        }
        this.getSearchResults(this.searchTerm);

    }

    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFocus() {
        document.body.classList.add('predictive-search--focus');
        const currentSearchTerm = this.getQuery();

        if (!currentSearchTerm.length) return;

        if (this.searchTerm !== currentSearchTerm) {
            // Search term was changed from other search input, treat it as a user change
            this.onChange();
        } else if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(this.searchTerm);
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onKeyup(event) {
        if (!this.getQuery().length) {
            this.clear(event);
            this.close(true);
        }
        event.preventDefault();

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up');
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }

    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (
            event.code === 'ArrowUp' ||
            event.code === 'ArrowDown'
        ) {
            event.preventDefault();
        }
    }

    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector(
            '[data-predictive-search-search-for-text]',
        );

        const currentButtonText = searchForTextElement?.innerText;
        if (currentButtonText) {
            /*
            if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
              // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
              return;
            }
            */
            const newButtonText = currentButtonText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = newButtonText;
        }
    }

    switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allElements = this.querySelectorAll('li');
        let activeElement = this.querySelector('li');

        if (moveUp && !selectedElement) return;

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
            activeElement = selectedElement.nextElementSibling || allElements[0];
        } else if (moveUp) {
            activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
        }

        if (activeElement === selectedElement) return;

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.setLiveRegionText(activeElement.textContent);
        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
        const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

        if (selectedProduct) selectedProduct.click();
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(' ', '-').toLowerCase();
        const perPage = this.dataset.perPage || 4;
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            if (this.modal) this.modal.classList.add('searching');
            return;
        }

        const queryParams = new URLSearchParams({
            q: searchTerm,
            "resources[limit]": perPage,
            "resources[limit_scope]": "each",
            section_id: "predictive-search",
            "resources[options][fields]": "title,product_type,variants.title,variants.sku"
          });
          
        const url = `${theme.routes.predictive_search_url}?${queryParams.toString()}`;

        fetch(url).then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error;
            }

            return response.text();
        }).then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

            // Save bandwidth keeping the cache in all instances synced
            this.allPredictiveSearchInstances.forEach(
                (predictiveSearchInstance) => {
                    predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
                },
            );
            /*
            this.cachedResults[queryKey] = resultsMarkup;
            */
            this.renderSearchResults(resultsMarkup);

            if (this.modal) this.modal.classList.add('searching');
        }).catch((error) => {
            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }

            this.close();
            throw error;
        });
    }

    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }

    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);
        this.setLiveRegionResults();
        this.open();
    }

    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
        this.resultsMaxHeight = window.innerHeight - document.querySelector('.header').getBoundingClientRect().bottom;
        return this.resultsMaxHeight;
    }

    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
        document.body.classList.add('predictive-search--focus');
    }

    close(clearSearchTerm = false) {
        this.closeResults(clearSearchTerm);
        this.isOpen = false;
    }

    closeResults(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }
        const selected = this.querySelector('[aria-selected="true"]');

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        document.body.classList.remove('predictive-search--focus');
    }


    clear(event) {
        if (event) event.preventDefault();

        this.input.value = '';
        this.removeAttribute('open');
        this.removeAttribute('results');
        this.input.focus();

        if (this.modal) this.modal.classList.remove('searching');
    }
}

customElements.define('predictive-search', PredictiveSearch);
